import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Placeholder for the Training module while it is paused for HRMS v1.
 * The full implementation lives in `TrainingManagement.jsx` and is intentionally
 * NOT deleted — the route is just swapped to this lightweight Coming Soon screen
 * so the module disappears from tester traffic without losing the existing code.
 */
export default function TrainingComingSoon() {
  return (
    <div
      data-testid="training-coming-soon"
      className="min-h-[60vh] flex items-center justify-center px-6"
    >
      <div className="max-w-xl w-full text-center bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-12 shadow-sm">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-2xl bg-emerald-100 dark:bg-emerald-900/30 mb-6">
          <GraduationCap className="h-8 w-8 text-emerald-600 dark:text-emerald-300" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-2">
          Training — Coming Soon
        </h1>
        <p className="text-sm text-slate-600 dark:text-slate-400 mb-6 leading-relaxed">
          The Training &amp; HRDF Claims module is being refined and is not part of
          the current MyHR Orbit v1 release. We&apos;re focused on stabilising the
          core modules first — Employees, Leave, Attendance, Claims, Payroll and
          Reports — and Training will be back in a future update.
        </p>
        <Link to="/dashboard">
          <Button
            variant="outline"
            className="border-slate-300 text-slate-800 hover:bg-slate-100 dark:border-slate-500 dark:text-slate-100 dark:hover:bg-slate-700"
            data-testid="training-coming-soon-back-btn"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
